import { httpClient } from "@/shared/services/http";

export class NormHttpService {
  static async getNormsByTestIds(clientId: number, assessmentId: number, testIds: number[]) {
    const searchParams = new URLSearchParams();
    searchParams.set("testIds", testIds.join(","));

    const search = searchParams.toString();
    const url =
      `/api/clients/${clientId}/assessments/${assessmentId}/tests/available-norms` + (search ? `?${search}` : "");
    const { data: norms } = await httpClient.get(url);

    return norms;
  }

  static async getNormsByAssessment(clientId: number, assessmentId: number) {
    const { data: norms } = await httpClient.get(`/api/clients/${clientId}/assessments/${assessmentId}/tests/norms`);

    return norms;
  }
}
